import { render, staticRenderFns } from "./fortunerabbit.vue?vue&type=template&id=0ca4cda2&scoped=true"
import script from "./fortunerabbit.vue?vue&type=script&lang=js"
export * from "./fortunerabbit.vue?vue&type=script&lang=js"
import style0 from "./fortunerabbit.vue?vue&type=style&index=0&id=0ca4cda2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca4cda2",
  null
  
)

export default component.exports